import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
    List,
    ListItem,
    ListItemText,
    makeStyles,
    ThemeProvider,
    Typography,
} from "@material-ui/core";
import Store from "@material-ui/icons/Store";

import manufacturerStyle, { theme } from "./ManufacturerStyle";
import { Creators as manufacturerActions } from "../../store/ducks/manufacturer";

const useStyles = makeStyles((theme) => manufacturerStyle(theme));

const Manufacturer = ({ getManufacturer, manufacturer }) => {
    const classes = useStyles();

    const { data, error, loading } = manufacturer;

    const [manufacturerProd, setManufacturerProd] = useState({
        codigo: "",
        contato: "",
        email: "",
        endereco: "",
        nome: "",
    });
    
    useEffect(() => {
        if (!data && !error && !loading) {
            getManufacturer();
        }

        if (data) {
            setManufacturerProd(data);
        }
    }, [data, loading, error, getManufacturer]);

    return manufacturerProd?.codigo ? (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Typography
                    component="h1"
                    variant="h5"
                    color="inherit"
                    noWrap
                    className={classes.title}
                >
                    <Store />
                    Fornecedor
                </Typography>
                <List component="nav" aria-label="main mailbox folders" >
                    <ListItem>
                        <ListItemText
                            disableTypography
                            primary={<Typography  className={classes.textPrimary}>Nome: </Typography>}
                            secondary={<Typography  className={classes.textSecondary}> {manufacturerProd.nome}</Typography>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            disableTypography
                            primary={<Typography  className={classes.textPrimary}>Código: </Typography>}
                            secondary={<Typography  className={classes.textSecondary}> {manufacturerProd.codigo}</Typography>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            disableTypography
                            primary={<Typography  className={classes.textPrimary}>Contato: </Typography>}
                            secondary={<Typography  className={classes.textSecondary}> {manufacturerProd.contato}</Typography>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            disableTypography
                            primary={<Typography  className={classes.textPrimary}>Email: </Typography>}
                            secondary={<Typography  className={classes.textSecondary}> {manufacturerProd.email}</Typography>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            disableTypography
                            primary={<Typography  className={classes.textPrimary}>Endereço: </Typography>}
                            secondary={<Typography  className={classes.textSecondary}> {manufacturerProd.endereco}</Typography>}
                        />
                    </ListItem>
                </List>
            </ThemeProvider>
        </React.Fragment>
    ) : (
        <Typography
            component="h1"
            variant="h5"
            color="inherit"
            noWrap
            className={classes.title}
        >
            <Store />
            Fornecedor
        </Typography>
    );
};

const mapStateToProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(manufacturerActions, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Manufacturer);
